/**
 * Created by jpilz on 2/13/17.
 */
"use strict";
import {context} from '../../../objects/context.js';
import $ from 'jquery';
import ko from 'knockout';
import optionsUtil from '../../../objects/optionsUtil.js';

import BootstrapDialog from 'bootstrap3-dialog/dist/js/bootstrap-dialog';

class internalUsersModel {

    constructor() {
        // Profile
        this.componentName = "internal-users";
        this.context = context;
        this.id = this.context.util.guid();
        this.visible = ko.observable(true);

        this.contentVisible = ko.observable(false);
        this.listArray = context.userEmployeeList;
        this.selectedItem = ko.observable(this.defaultUser());

        this.name = ko.observable("").extend({ required: { params: true, message: 'This field is required.' }, minLength: { params: 3, message: 'Min length of 3 characters' } });
        this.email = ko.observable("").extend({ required: { params: true, message: 'This field is required.' }, email: true });
        this.title = ko.observable("").extend({ required: { params: true, message: 'This field is required.' }, minLength: { params: 3, message: 'Min length of 3 characters' } });
        this.selectedRole = ko.observable(1);

        this.addEditStatus = ko.observable(true);
        this.roleVisible = ko.observable(false);

        this.saveButtontitle = ko.observable("Add User");

        this.errors = ko.validation.group(this, { deep: false });

        console.log("internal-users:");
        console.log(this.selectedItem());

        this.init();
        
    }

    init() {

        let self = this;

        this.selectedItem.subscribe(function (newSelection) {
            console.log(newSelection);
            try {

                if(newSelection.name == "Add New User")
                {
                    self.name("");
                    self.email("");
                    self.title("");
                    self.saveButtontitle("Add New User");
                }
                else
                {
                    self.name(newSelection.name);
                    self.email(newSelection.email);
                    self.title(newSelection.title);
                    self.saveButtontitle("Update User");
                }
                
            }
            catch(err)
            {
                //console.log(err);
            }            
         });
    }
        
    toggleContent() {

        this.contentVisible(!this.contentVisible());

        if(this.contentVisible())
        {
            //this.getData();
        }
    }

    defaultUser() {
        return {"userid": null, "subid": " ", "partnerid": 1, "email": " ", "title": " ", "valid": 1,"password": " ", "jdmuserroleid": 1, "name": "Choose..."};
    }

    validate() {

        console.log("validate: " + this.errors());
    }

    getData() {
        
        let oUtil = new optionsUtil(this.context);
        let self = this;
        this.listArray([]);
        oUtil.getOptions(this.componentName).then(function (result) {
            console.log(result);
            self.listArray(result) 
        } );

    }

    sendUpdate() {
        $('.validationMessage').removeClass('hidden');
        let oUtil = new optionsUtil(this.context);
        let self = this;
        oUtil.updateOptions(this.componentName,this.selectedItem()).then(function (result) {
            console.log(result);
            self.getData();
        } );
    }

    clickResetUserPasswordConfirm() {

        let self = this;

        BootstrapDialog.confirm({

            title: 'Reset Password',
            message: 'Are you sure you want to rest the password? <br><br><small>The user will be asked to enter a new password on login,', 
            type: BootstrapDialog.TYPE_WARNING,

            callback: function(result){
                if(result) {
                    console.log('internal-users:clickResetUserPasswordConfirm result %o', result);
                    self.resetPassword();
                } 
            }
        });

    }

    resetPassword() {

        console.log('internal-users:resetPassword  selectedItem %o', this.selectedItem);

        let optionsUtilObj = new optionsUtil(this.context);

        optionsUtilObj.resetPassword(this.selectedItem).then( result => {

            console.log('internal-users:resetPassword  result %o', result);
            
        }).catch( result => {
            
            console.log('internal-users:resetPassword  ERROR %o', result);
        });



    }


    clickDeleteUserConfirm() {

        let self = this;

        BootstrapDialog.confirm({

            title: 'User DELETE',
            message: 'Are you sure you want to DELETE this user?', 
            type: BootstrapDialog.TYPE_DANGER,

            callback: function(result){
                if(result) {
                    console.log('internal-users:clickDeleteUserConfirm result %o', result);
                    self.deleteUser();
                } 
            }
        });

    }

    deleteUser() {
        this.selectedItem().valid = 0;
        this.saveUser();
    }

    saveUser() {

        console.log("saveUser");
        $('.validationMessage').removeClass('hidden');
        console.log(this.selectedItem());

        if(this.errors().length === 0)
        {
            this.selectedItem().name = this.name();
            this.selectedItem().email = this.email();
            this.selectedItem().title = this.title();

            console.log(this.selectedItem());
            this.sendUpdate();
        }
        else
        {
            console.log("saveUser: Error");
            console.log(this.errors());
        }
    }

    clearForm() {
        
       
        $("#userList").prop('selectedIndex', 0);
        this.saveButtontitle("Add User");
        this.name("");
        //this.name.clearError();
        //this.name.isModified(false);
        this.email("");
        //this.email.clearError();
        //this.email.isModified(false);
        this.title("");
        //this.title.clearError();
        //this.title.isModified(false);

        this.errors.showAllMessages(false);

        $('.validationMessage').addClass('hidden');

        console.log('internal-users:clearForm:  this.errors:  %o', this.errors());
        
       
        
        //this.selectedItem(this.defaultUser());
    }


}

export default { viewModel: internalUsersModel, template: require('!raw-loader!./internal-users.html') };


// WEBPACK FOOTER //
// ./src/components/options/internal-users/internal-users.js